// src/pages/Menu.tsx

import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';

const Menu: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#f5f5f5', py: 8 }}>
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography variant="h4" sx={{ color: '#3e2723', mb: 4 }}>
          View Our Menu
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, color: '#5c4033' }}>
          Discover our latest food and drink selection in the link below.
        </Typography>

        <Button
          variant="contained"
          href="https://www.canva.com/design/DAG6b6KnFDc/ealQPhklnFXGRFmal9UXXw/view?utm_content=DAG6b6KnFDc&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h1911afd27a"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            bgcolor: '#A52A2A',
            color: '#fff',
            px: 5,
            py: 2,
            fontSize: '18px',
            borderRadius: '12px',
            textTransform: 'none',
            '&:hover': {
              bgcolor: '#8B0000',
            },
          }}
        >
          📜 View Our Full Menu
        </Button>
      </Container>
    </Box>
  );
};

export default Menu;
